export const environment = {
  production: true,
  info: {
    publicUrl: 'https://search.wbrclerk.org/login',
    district: '18TH',
    city: 'PORT ALLEN',
    parish: 'WEST BATON ROUGE',
    url: 'search.wbrclerk.org',
    logo: 'seal_wbr.png',
    clerkName: 'AMANDA GROSS THIES',
    clerkAddress: 'PO BOX 107',
    clerkCityStateZip: 'PORT ALLEN, LA  70767',
    clerkPhone: '(225) 383-0378',
    clerkWeb: 'www.wbrclerk.org',
    email: 'info@wbrclerk.org',
    civilFees: '',
    videoUrl: ''
  },
  civilFees: {
    subpoenas: 0,
  },
  dates: {
    civil: null,
    criminal: 473464914000,
    conveyances: null,
    mortgages: null,
    recording: null,
    marriages: null,
  },
  recaptcha: {
    siteKey: '6LdLiAkfAAAAAFPOiMQDoGm8peuoy8vPVuoIZttK'
  },
  mconfig: {
    url: 'https://cnmswbr.clerknet.app',
    apiKey: '4d379da16f2c9639cfb01720cee199cd43b8d6c006c784e2cdf3dc78288317db',
    civil: '',
    host: 'https://cnmswbr.clerknet.app',
    api: '',
    key: '4d379da16f2c9639cfb01720cee199cd43b8d6c006c784e2cdf3dc78288317db',
    criminal: 'cnwbrcriminal',
  },
  sb: {
    databaseurl: '',
    databasekey: '',
    i: '',
    n: '',
    url: '',
    key: ''
  },
  aconfig: {
    appId: 'RZYQ3P4JBS',
    apiKey: '18f2496e8324ee32d8167b7e51f57e6d',
    CIVIL: '',
    RECORDING: '',
    CRIMINAL: 'wbrCriminalCases',
    AUDIT: 'publicAudit',
  },
  afs: {
    civ: '',
    civpub: '',
    civfolder: '',
    crimpub: 'cnlawbrcriminal_pub',
    recpub: '',
    crimfolder: 'cnCriminal',
    crim: 'cnlawbrcriminal',
    recfolder: '',
    rec: '',
    eRecording: '',
    eFiling: 'cnlawbrefiling',
  },
  firebaseConfig: {
    apiKey: "AIzaSyD1AYjaw500FQQLADZWU1ObcoQ-V7ffDOk",
    authDomain: "clerknetlawbr.firebaseapp.com",
    projectId: "clerknetlawbr",
    storageBucket: "clerknetlawbr.appspot.com",
    messagingSenderId: "342587090718",
    appId: "1:342587090718:web:c442060664fd3e638c0b0f"
  },
  stripe: {
    plans: [
      {
        name: '24 HOUR',
        rate: 20,
        fee: .91,
        total: 20.91,
        discount: '',
        planId: 'price_1Sw3qxEM9l9AiAaZF9TROkQw'
      },
      {
        name: '1 MONTH',
        rate: 50,
        fee: 1.8,
        total: 51.80,
        discount: '',
        planIdRenewal: 'price_1Sw3ubEM9l9AiAaZxmiiFWme',
        planId: 'price_1Sw3u6EM9l9AiAaZ77XbhYPP'
      },
      {
        name: 'YEARLY',
        rate: 500,
        fee: 15.24,
        total: 515.24,
        discount: '',
        planIdRenewal: 'price_1Sw3v9EM9l9AiAaZ0KA02J8I',
        planId: 'price_1Sw3tcEM9l9AiAaZe5qahrW1'
      }
    ],
    clerknet: 'pk_live_514ffBuFDbduv4AUe0WNSqOQXa9Ucn7XyYE4gGbHSPTQP9laJYhc0WLAC9pn8psLh7mV6Qq8NS7ta1PzSKUygzKvA00tZ0iBHHF',
    clerknetTest: '',
    civilAcct: '',
    recAcct: 'acct_1SeOWeEM9l9AiAaZ',
    connect: '',
    recording: 'pk_live_51SeOWeEM9l9AiAaZubwUJnYbF0JQ4hGtq51TNB3LFeAzvry2e5IzYuVHeI7DycUgZk8OL1pRAlwOZaFktqqpoXQ700KP315S8v',
    recordingTest: '',
    civil: '',
    civilTest: ''
  }
};
